// src/components/Footer.jsx
import React from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          {/* Column 1 - About */}
          <div className="footer-col">
            <h2 className="footer-logo-title">
              Vivek Vardhini
              <span>Creative Minds School</span>
            </h2>
            <p className="footer-tagline">Where curiosity meets character.</p>
            <p className="footer-small">CBSE curriculum | Holistic learning</p>

            <div className="social-icons">
              <a
                href="https://www.facebook.com/vvcreativemindsschool"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/vvcreativemindsschool/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://wa.me/918977753424"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="footer-col">
            <h3>Explore</h3>
            <ul>
              <li>
                <a href="#about-vvcms">About VVCMS</a>
              </li>
              <li>
                <a href="#innovation-infra">Innovation &amp; Infrastructure</a>
              </li>
              <li>
                <a href="#admissions">Admissions</a>
              </li>
              <li>
                <a href="#support-desk">Support &amp; Enquiry</a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div className="footer-col">
            <h3>Contact</h3>
            <p>
              <FaMapMarkerAlt /> Hyderabad, Telangana
            </p>
            <p>
              <FaPhone /> +91-63008971671
            </p>
            <p>
              <FaEnvelope /> vvcmschool@gmail.com
            </p>
          </div>

          {/* Column 4 - Newsletter */}
          <div className="footer-col">
            <h3>Stay Updated</h3>
            <p>Get school news, events &amp; admission updates in your inbox.</p>
            <div className="newsletter">
              <input type="text" placeholder="Your email address" />
              <button aria-label="Subscribe">→</button>
            </div>
          </div>
        </div>

        <hr />
        <p className="footer-bottom">
          © {new Date().getFullYear()} Vivek Vardhini Creative Minds School. All
          rights reserved.
        </p>

        {/* Powered by VRND */}
        <div className="footer-powered">
          <a
            href="https://vrnd.tech/"
            target="_blank"
            rel="noreferrer"
            className="powered-btn"
          >
            Powered by VRND Business Solutions
          </a>
        </div>
      </footer>

      {/* Floating WhatsApp icon */}
      {/*<a
        className="whatsapp-float"
        href="https://wa.me/+91-8977753424"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
      </a>*/}
    </>
  );
};

export default Footer;
